import { render } from "./Embed.vue?vue&type=template&id=d0821fee"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"

import "./Embed.vue?vue&type=style&index=0&id=d0821fee&lang=scss"
script.render = render

export default script